//core
import React, { useEffect } from "react";
import { useFormikContext, Field } from "formik";
// @ts-ignore
import Big from "big.js"

//hooks
import useDidMountEffect from "../../../../../../customHooks/useDidMountEffect";
import { useFields } from "../../../../../../store/common/fields/useFields";
import { useSummaryReport } from "../../../../../../store/admin/reports/summary_report_v2/useSummaryReport";


interface IHelperField {
  values: any;
}

const HelperField = (props:IHelperField) => {
  const { values } = props;

  const {
    setFieldValue,
  } = useFormikContext();
	const { clearTrackers } = useFields();
	const { clearCurrencies } = useSummaryReport();

	useDidMountEffect(() => {
		clearTrackers();
		setFieldValue('trackerId', '');
	}, [values.affiliateId]);

	useDidMountEffect(() => {
		clearCurrencies();
		setFieldValue('brandCurrency', '');
	}, [values.brand]);

  return (
    <>
      <Field hidden />
    </>
  );
};

export default HelperField;
